import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/ExtensionInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/extensions`;
	}
	listExtensionsByProjectId(e, t = {}) {
		return this.api.get(this.buildPath(`${n.baseUrl}/project`, {
			...t,
			projectId: e
		}));
	}
};
//#endregion
export { n as ExtensionInternalResource };

//# sourceMappingURL=ExtensionInternalResource.js.map